import { CountryCode, ProvinceCode } from '../geo/geo.types';

export type PayersActionTypes =
  'GET_PAYERS' | 'GET_PAYERS_PENDING' | 'GET_PAYERS_FULFILLED' | 'GET_PAYERS_REJECTED' |
  'REGISTER_PAYER' | 'REGISTER_PAYER_PENDING' | 'REGISTER_PAYER_FULFILLED' | 'REGISTER_PAYER_REJECTED' |
  'UPDATE_PAYER' | 'UPDATE_PAYER_PENDING' | 'UPDATE_PAYER_FULFILLED' | 'UPDATE_PAYER_REJECTED' |
  'REVERT_TO_INITIAL_STATE' | 'REVERT_TO_INITIAL_STATE_EXCEPT_AUTH';

export const initialPayersState: PayersState = {
  statusCode: 0,
  payers: []
};

export type PayersState = {
  readonly statusCode: number,
  readonly newPayer?: PayerInfo,
  readonly updatedPayer?: PayerInfo,
  readonly payers: PayerInfo[]
};

export type PayMethodsActionTypes =
  'GET_PAYMETHODS' | 'GET_PAYMETHODS_PENDING' | 'GET_PAYMETHODS_FULFILLED' | 'GET_PAYMETHODS_REJECTED' |
  'REGISTER_PAYMETHODS' | 'REGISTER_PAYMETHODS_PENDING' | 'REGISTER_PAYMETHODS_FULFILLED' |
  'REGISTER_PAYMETHODS_REJECTED' | 'REMOVE_PAYMETHODS' | 'REMOVE_PAYMETHODS_PENDING' |
  'REMOVE_PAYMETHODS_FUFILLED' | 'REMOVE_PAYMETHODS_REJECTED' |
  'REVERT_TO_INITIAL_STATE' | 'REVERT_TO_INITIAL_STATE_EXCEPT_AUTH';

export const initialPayMethodsState: PayMethodsState = {
  statusCode: 0,
  payMethods: []
};

export type PayMethodsState = {
  readonly statusCode: number,
  readonly payMethods: PayMethodsInfo[]
  readonly newPayMethod?: PayMethodsInfo
};

export type BillingEntity = {
  readonly msg: string,
  readonly list: any[];
  readonly entity: any;
};

export type BillingResponseData = {
  readonly statusCode: number,
  readonly json: Promise<BillingEntity>
};

export type BillingDetailsMode = 'DISPLAY' | 'EDIT' | 'CREATE';

export type Currency = 'CAD' | 'USD';

export type PaymentMethod = 'VOIDCHEQUE' | 'CREDITCARD' | 'CASH';

export interface PayerInfo {
  readonly id: number;
  readonly firstName: string;
  readonly initial: string;
  readonly lastName: string;
  readonly address: string;
  readonly city: string;
  readonly country: CountryCode | '';
  readonly province: ProvinceCode | '';
  readonly postalCode: string;
  readonly mobile1: string;
  readonly mobile2: string | undefined;
  readonly email: string;
  readonly payingMembers: number[];
}

export interface PayMethodsInfo {
  readonly id: number;
  readonly paymentMethodType: string;
  /* void cheque information start */
  readonly accountHolderName: string;
  readonly financialInstitutionName: string;
  readonly transitNumber: string;
  readonly maskedTransitNumber: string;
  readonly financialInstitutionNumber: string;
  readonly bankAccountNumber: string;
  readonly maskedBankAccountNumber: string;
  /* credit card information start */
  readonly cardHolderName: string;
  readonly cardNumber: string;
  readonly expiryMonth: string;
  readonly expiryYear: string;
  readonly cvc: string;
  readonly payer: PayerInfo;
}


// WEBPACK FOOTER //
// ./src/billing/billing.types.tsx